import React, { useContext, useEffect, useState } from 'react';
import { Button, Fade, FormControlLabel, Grid, makeStyles, Radio, RadioGroup } from '@material-ui/core';
import { AccountCircle } from '@material-ui/icons';
import { LoginAPI } from '../../services/LoginAPI';
import { AppContext } from '../../contexts/AppContext';
import RegexTextField from '../../components/UI/RegexTextField';
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import { isValidEmail } from '../../utils/MiscellaneousUtils';
import { Bold } from '../../components/UI/TextFormatters';
import AnimatedButton from '../../components/UI/AnimatedButton';
import { ROUTES } from '../../constants/RoutingConstants';
import { useHistory } from 'react-router';
import { separations } from '../../constants/StyleConstants';
import { EMPLOYEE, SUPPLIER_TYPES } from '../../constants/GlobalConstants';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '100vh',
    background: `radial-gradient(at top left, #FF00FF12 40%, ${theme.palette.primary.main} 100%)`,
  },
  loginCard: {
    display: 'flex',
    width: 380,
    height: 400,
    borderRadius: 10,
    padding: 10,
    overflow: 'hidden',
    boxShadow: '0 0 30px 0 rgba(0,0,0,.5)',
    backgroundColor: 'white',
    '@supports (backdrop-filter: blur(10px))': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      backdropFilter: 'blur(10px)',
    },
  },
  loginForm: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '1em',
    padding: '0 0.5em 0 1em',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  loginField: {
    width: '100%',
  },
  loginManagmentOptions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
  },
  loginManagmentBtn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loginBtn: {
    margin: '2em 0 1em 0',
    borderRadius: 10,
  },
  fillBlankSpace: {
    height: '5em',
  },
  messageWrapper: {
    position: 'absolute',
    textAlign: 'center',
    padding: '0 1em 0 1em',
    top: '50%',
    transition: '1s !important',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '1em',
  },
  radioGroup: {
    alignContent: 'center'
  },
  ...separations,
}));

const CuitInput = ({ fieldValue, setFieldValue, isLocalSupplier }) => {
  const classes = useStyles();
  const [value, setValue] = useState(fieldValue);
  const [focus, setFocus] = useState(false);
  const onlyNumbers = /[^0-9]/gi;

  const reg = /^(\\d+|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,})$/

  return (
    <div className={classes.loginField}>
      <Grid container spacing={1} alignItems="flex-end">
        <Grid item>
          <AccountCircle color={focus ? 'primary' : 'action'} />
        </Grid>
        <Grid item xs={10}>
          <RegexTextField
            //regex={onlyNumbers}
            regex={reg}
            fullWidth
            id="input-with-icon-grid"
            label={isLocalSupplier ? 'CUIT' : 'Código Proveedor'}
            value={value}
            onChange={event => setValue(event.target.value)}
            onBlur={() => setFieldValue(value)}
            onBlurCapture={() => setFocus(false)}
            onFocus={() => setFocus(true)}
          />
        </Grid>
      </Grid>
    </div>
  );
};

const MailInput = ({ fieldValue, setFieldValue }) => {
  const classes = useStyles();
  const [value, setValue] = useState(fieldValue);
  const [focus, setFocus] = useState(false);
  const onlyEmailCharacters = /[^a-zA-Z0-9_\-@.]/g;

  return (
    <div className={classes.loginField}>
      <Grid container spacing={1} alignItems="flex-end">
        <Grid item>
          <AlternateEmailIcon color={focus ? 'primary' : 'action'} />
        </Grid>
        <Grid item xs={10}>
          <RegexTextField
            regex={onlyEmailCharacters}
            fullWidth
            id="inputMail-with-icon-grid"
            label="E-Mail"
            value={value}
            onChange={event => setValue(event.target.value)}
            onBlur={() => setFieldValue(value)}
            onBlurCapture={() => setFocus(false)}
            onFocus={() => setFocus(true)}
          />
        </Grid>
      </Grid>
    </div>
  );
};

const SuccessMessage = ({ showMessage, email, forgotPassword }) => {
  const classes = useStyles();

  return (
    <div className={classes.messageWrapper}>
      <Fade timeout={500} in={showMessage}>
        <div>
          Se ha envíado un mail a <Bold>{email}</Bold>.<br></br>
          <br></br>
          {forgotPassword
            ? 'En el mismo dispondrá de un link para completar el proceso de cambio de password.'
            : 'En el mismo dispondrá de un link para completar la registración.'}
          <br></br>
          <br></br>
          Puede cerrar esta página ahora.
        </div>
      </Fade>
    </div>
  );
};

const CredentialsRequest = ({ forgotPassword }) => {
  const classes = useStyles();
  const { showError, showWarning } = useContext(AppContext);
  const [email, setEmail] = useState('');
  const [cuit, setCuit] = useState('');
  const [cardIn, setCardIn] = useState(false);
  const [fadeIn, setFadeIn] = useState(true);
  const [showMessage, setShowMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [groupType, setGroupType] = useState(SUPPLIER_TYPES.LOCAL);
  const history = useHistory();

  /* INICIO FIX para issue con Chrome. Autocomplete de user y password no dispara onChange */
  useEffect(() => {
    groupType !== EMPLOYEE.EMPLOYEE ? setCuit(document.getElementById('input-with-icon-grid').value) : setCuit(document.getElementById('inputMail-with-icon-grid').value);
    setEmail(document.getElementById('inputMail-with-icon-grid').value);
  }, [cuit, email]);
  /* FIN FIX para issue con Chrome. Autocomplete de user y password no dispara onChange */

  const validate = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if(groupType !== EMPLOYEE.EMPLOYEE){
      if ((errors[i++] = cuit.isBlank())) {
        errorMessages.push('Debe completar el CUIT/Código');
      } //else if ((errors[i++] = groupType === SUPPLIER_TYPES.LOCAL && (/^[^37][0-9]*/gi).test(cuit))) {
        else if ((errors[i++] = groupType === SUPPLIER_TYPES.LOCAL && !(/^(\d+|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/).test(cuit))) {
        errorMessages.push(`Debe ingresar un CUIT/Email válido`);
      }
    }

    if ((errors[i++] = email.isBlank())) {
      errorMessages.push('Debe completar el email del usuario');
    } else if ((errors[i++] = !isValidEmail(email))) {
      errorMessages.push('El email ingresado no es válido');
    }

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const handleCredentialsRequest = () => {
    if (validate()) {
      setLoading(true);
      const isExternal = groupType === SUPPLIER_TYPES.EXTERNAL ? 'E' : 'I';
      const serviceCall = forgotPassword ? LoginAPI.forgotPassword(cuit, email, isExternal) : LoginAPI.signUp(cuit, email, isExternal);

      serviceCall
        .then(res => {
          setShowMessage(true);
        })
        .catch(({ response: { data } }) => {
          setLoading(false);
          const dataErrorMessages = {
            'El usuario ya existe': 'El CUIT/Código que intenta registrar ya se encuentra en uso, por favor ingrese con CUIT/Código y contraseña generada o resetee su clave en la opción "Olvide mi Clave"',
            'El usuario no existe': "El CUIT/Código ingresado no está autorizado para el registro",
            'Email no registrado en SAP': "¡Verificar mail! \n Debe ingresar el mail donde recibe órdenes de pago / compras",
            'Email incorrecto': "Mail Incorrecto",
            'CUIT incorrecto' : "CUIT incorrecto",
            'Proveedor no existe en SAP':"El CUIT/Código no esta registrado en SAP"
          };
          const dataErrorMessagesForgetPassword = {
            'El usuario ya existe': 'El CUIT/Código que intenta registrar ya se encuentra en uso, por favor ingrese con CUIT/Código y contraseña generada o resetee su clave en la opción "Olvide mi Clave"',
            'El usuario no existe': 'CUIT/Código Incorrecto',
            'Email no registrado en SAP': "¡Verificar Mail! \n Debe ingresar el mail donde recibe órdenes de pago / compras",
            'Email incorrecto': "Debe ingresar con el Mail donde habitualmente recibe las órdenes de pago / órdenes de compra; o el que hayan registrado en el portal",
            'CUIT incorrecto' : "CUIT incorrecto",
            'Proveedor no existe en SAP':"El CUIT/Código no esta registrado en SAP"
          }
          const dataError = dataErrorMessages[data];
          const dataErroForgetPassword = dataErrorMessagesForgetPassword[data];
          const message = forgotPassword ? dataErroForgetPassword : dataError;
          const errorMessages = data.errors ? Object.values(data.errors) : [data];
          showError(message, errorMessages);
        });
    }
  };

  const executeTransition = action => {
    setCardIn(false);
    setTimeout(() => {
      setFadeIn(false);
      setTimeout(() => action(), 250);
    }, 500);
  };

  const redirectLogin = () => {
    executeTransition(() => history.push(ROUTES.LOGIN.SUPPLIER));
  };

  return (
    <Fade in={fadeIn} timeout={500} onEntered={() => setCardIn(true)}>
      <div className={classes.root}>
        <Fade timeout={1000} in={cardIn}>
          <div className={classes.loginCard}>
            <div style={{ position: 'relative' }} className={classes.loginForm}>
              <SuccessMessage showMessage={showMessage} email={email} forgotPassword={forgotPassword} />
              <img alt="" src={process.env.PUBLIC_URL + '/images/logo.png'} width="55%" />
              <Fade timeout={1000} in={!showMessage} appear>
                <div style={{ width: '100%' }}>
                  <RadioGroup className={clsx(classes.radioGroup, classes.topSeparation)} aria-label="supplierType" name="supplierType" 
                    value={groupType} onChange={e => setGroupType(e.target.value)}>
                    <FormControlLabel value={SUPPLIER_TYPES.LOCAL} control={<Radio color="primary" />} label={SUPPLIER_TYPES.LOCAL} />
                    <FormControlLabel value={SUPPLIER_TYPES.EXTERNAL} control={<Radio color="primary" />} label={SUPPLIER_TYPES.EXTERNAL} />
                    {forgotPassword && <FormControlLabel value={EMPLOYEE.EMPLOYEE} control={<Radio color="primary" />} label={EMPLOYEE.EMPLOYEE} />}
                  </RadioGroup>
                  <div className={classes.loginForm}>
                    {groupType !== EMPLOYEE.EMPLOYEE && <CuitInput fieldValue={cuit} setFieldValue={setCuit} isLocalSupplier={groupType === SUPPLIER_TYPES.LOCAL}/>}
                    <MailInput fieldValue={email} setFieldValue={setEmail} />
                  </div>
                  <div className={classes.actions}>
                    <AnimatedButton
                      className={classes.loginBtn}
                      variant="contained"
                      color="primary"
                      onClick={handleCredentialsRequest}
                      loading={loading}>
                        {forgotPassword ? 'Recuperar contraseña' :'Registrarse'}
                      
                    </AnimatedButton>
                    <Button className={classes.loginBtn} variant="contained" color="primary" onClick={redirectLogin}>
                      Volver
                    </Button>
                  </div>
                </div>
              </Fade>
            </div>
          </div>
        </Fade>
      </div>
    </Fade>
  );
};

export default CredentialsRequest;
